(() => {
  const dialog = document.getElementById('lc-accommodation-dialog');
  if (!dialog) return;
  const find = (name) => dialog.querySelector(`.lc-accommodation__${name}`);
  const title = dialog.querySelector('h2');
  const content = find('content');
  const status = find('status');
  const retry = find('retry');
  const gallery = find('gallery');
  const image = find('image');
  const thumbs = find('thumbs');
  const cache = new Map();
  const detailsMap = JSON.parse(dialog.querySelector('[data-accommodation-details-map]')?.textContent || '{}');
  let photos = [];
  let index = 0;
  let requestId = 0;
  let current;
  let trigger;

  function isWithoutAccommodation(input) {
    return /sans\s+h[ée]bergement/i.test(input?.value || '');
  }

  function productHandle(input) {
    return isWithoutAccommodation(input)
      ? dialog.dataset.noAccommodationHandle
      : input?.getAttribute('gpo-data-product-handle');
  }

  function imageUrl(src, width) {
    const url = new URL(src, location.origin);
    url.searchParams.set('width', String(width));
    return url.href;
  }

  function showPhoto(next) {
    if (!photos.length) return;
    index = (next + photos.length) % photos.length;
    image.src = imageUrl(photos[index], 1200);
    image.alt = `${title.textContent} — photo ${index + 1}`;
    find('counter').textContent = `${index + 1} / ${photos.length}`;
    [...thumbs.children].forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
    const selected = thumbs.children[index];
    if (selected) thumbs.scrollLeft = selected.offsetLeft - thumbs.offsetLeft - (thumbs.clientWidth - selected.clientWidth) / 2;
  }

  function render(product, variantId) {
    title.textContent = product.title;
    photos = [...new Set((product.images || []).map((item) => typeof item === 'string' ? item : item.src).filter(Boolean))];
    const variant = product.variants?.find((item) => String(item.id) === variantId);
    if (current.kind === 'pension' && variant?.title && variant.title !== 'Default Title' && variant.title !== product.title) {
      title.textContent = `${product.title} — ${variant.title}`;
    }
    const featured = variant?.featured_image?.src;
    if (featured) photos = [featured, ...photos.filter((src) => src !== featured)];
    gallery.hidden = photos.length === 0;
    thumbs.replaceChildren();
    photos.forEach((src, i) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', `Voir la photo ${i + 1}`);
      const thumbnail = document.createElement('img');
      thumbnail.src = imageUrl(src, 160);
      thumbnail.alt = '';
      thumbnail.loading = 'lazy';
      button.append(thumbnail);
      button.addEventListener('click', () => showPhoto(i));
      thumbs.append(button);
    });
    find('prev').hidden = find('next').hidden = thumbs.hidden = photos.length < 2;
    const description = find('description');
    const html = new DOMParser().parseFromString(product.description || '', 'text/html');
    html.querySelectorAll('script, style, iframe, object, embed, form, link, meta').forEach((el) => el.remove());
    html.body.querySelectorAll('*').forEach((el) => {
      [...el.attributes].forEach((attr) => {
        if (/^on/i.test(attr.name) || /^(javascript|vbscript|data):/i.test(attr.value.trim())) el.removeAttribute(attr.name);
      });
    });
    description.replaceChildren(...html.body.childNodes);
    if (!description.textContent.trim() && !description.querySelector('img')) description.textContent = current.kind === 'pension'
      ? 'Aucune description disponible pour cette pension.'
      : 'Aucune description disponible pour cet hébergement.';
    status.hidden = true;
    content.hidden = false;
    showPhoto(0);
  }

  async function load() {
    const id = ++requestId;
    content.hidden = true;
    retry.hidden = true;
    status.hidden = false;
    status.textContent = current.kind === 'pension' ? 'Chargement de votre pension…' : 'Chargement de votre hébergement…';
    dialog.setAttribute('aria-busy', 'true');
    const { handle, variantId } = current;
    try {
      let product = cache.get(handle);
      if (!product) {
        const response = await fetch(`${dialog.dataset.productsUrl}${encodeURIComponent(handle)}.js`);
        if (!response.ok) throw new Error('Product unavailable');
        product = await response.json();
        cache.set(handle, product);
      }
      if (id === requestId && dialog.open) render(product, variantId);
    } catch {
      if (id !== requestId || !dialog.open) return;
      status.textContent = 'Impossible de charger les détails de ce produit. Veuillez réessayer.';
      retry.hidden = false;
    } finally {
      if (id === requestId) dialog.removeAttribute('aria-busy');
    }
  }

  function addLinks() {
    document.querySelectorAll('.product-details .gpo-swatches.image-swatches.gpo-ov-item, .product-details .gpo-swatches.buttons.gpo-ov-item').forEach((card) => {
      const input = card.querySelector('input[type="radio"]');
      const pension = card.classList.contains('buttons') && /pension/i.test(input?.getAttribute('data-field-name') || input?.name || '');
      if (!card.classList.contains('image-swatches') && !pension) return;
      if (!productHandle(input) || /aucun/i.test(input.value)) return;
      if (pension) card.classList.add('mc-pension-card');
      if (card.querySelector('.mc-heb-more')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mc-heb-more';
      button.textContent = pension ? 'Plus d’infos' : 'Plus d’info';
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', dialog.id);
      card.append(button);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.product-details .mc-heb-more');
    if (!button) return;
    const input = button.closest('.gpo-ov-item')?.querySelector('input[type="radio"]');
    const handle = productHandle(input);
    if (!handle) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    trigger = button;
    current = {
      handle: detailsMap[handle] || handle,
      variantId: detailsMap[handle] || isWithoutAccommodation(input) ? '' : input.getAttribute('gpo-data-variant-id') || '',
      kind: button.closest('.mc-pension-card') ? 'pension' : 'accommodation',
    };
    gallery.setAttribute('aria-label', current.kind === 'pension' ? 'Photos de la pension' : 'Photos de l’hébergement');
    find('close').setAttribute('aria-label', 'Fermer les détails du produit');
    title.textContent = input.value || 'Votre hébergement';
    if (!dialog.open) dialog.showModal();
    dialog.scrollTop = 0;
    load();
  }, true);
  find('close').addEventListener('click', () => dialog.close());
  retry.addEventListener('click', load);
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => {
    requestId++;
    dialog.removeAttribute('aria-busy');
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  });
  find('prev').addEventListener('click', () => showPhoto(index - 1));
  find('next').addEventListener('click', () => showPhoto(index + 1));
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      showPhoto(index + (event.key === 'ArrowLeft' ? -1 : 1));
    }
  });
  addLinks();
  const details = document.querySelector('.product-details');
  if (details) new MutationObserver(addLinks).observe(details, { childList: true, subtree: true });
})();
